import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./faq.css";

const faqData = [
  {
    question: "Wie kann ich Mitglied werden?",
    answer:
      'Besuche unsere Seite "Mitglied werden" und fülle das Formular aus. Wir melden uns bei dir!',
  },
  {
    question: "Welche Aktivitäten bietet der Verein?",
    answer:
      "Wir bieten Sportgruppen, soziale Projekte und regelmäßige Veranstaltungen an.",
  },
  {
    question: "Was kostet eine Mitgliedschaft beim VfB Johannesberg?",
    answer:
      "Unsere Mitgliedsbeiträge sind wie folgt: Einzelmitgliedschaft 40 €/Jahr, Familienmitgliedschaft 50 €/Jahr. Für bestimmte Abteilungen wie Skateboard oder Damengymnastik können zusätzliche Trainingsgebühren anfallen.",
  },
];

const FAQ = () => {
  return (
    <section className="faq-section container my-5">
      <h2 className="section-title mb-4 faq-title">Häufig gestellte Fragen</h2>
      <div className="accordion" id="faqAccordion"> 
        {faqData.map((item, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`faq${index}`}>
              <button
                // Always add the "collapsed" class
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                // Always set aria-expanded to "false" initially
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {item.question}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              // Remove the conditional "show" class and fix typo from lassName to className
              className="accordion-collapse collapse"
              aria-labelledby={`faq${index}`}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;